package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.ComboboxDemo

@Page
@Composable
fun ComboboxPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/combobox.md", mapOf("title" to listOf("Combobox"), "description" to listOf("Autocomplete input and command palette with a list of suggestions.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import lucide_react.Check
import lucide_react.ChevronsUpDown
import react.FC
import react.Props
import react.dom.aria.AriaRole
import react.dom.aria.ariaExpanded
import react.useState
import shadcn.ui.components.*
import web.cssom.ClassName

val frameworks = mapOf(
    "next.js" to "Next.js",
    "sveltekit" to "SvelteKit",
    "nuxt.js" to "Nuxt.js",
    "remix" to "Remix",
    "astro" to "Astro"
)

val ComboboxDemo = FC<Props> {
    val (open, setOpen) = useState(false)
    val (value, setValue) = useState("")

    Popover {
        this.open = open
        onOpenChange = { setOpen(it) }
        PopoverTrigger {
            asChild = true
            Button {
                variant = "outline"
                role = AriaRole.combobox
                ariaExpanded = open
                className = ClassName("w-[200px] justify-between")
                + (frameworks[value] ?: "Select framework...")
                ChevronsUpDown { className = ClassName("ml-2 h-4 w-4 shrink-0 opacity-50") }
            }
        }
        PopoverContent {
            className = ClassName("w-[200px] p-0")
            Command {
                CommandInput {
                    placeholder = "Select framework..."
                }
                CommandEmpty { + "No framework found" }
                CommandGroup {
                    frameworks.forEach { (k,v) ->
                        CommandItem {
                            key = k
                            onSelect = {it: String ->
                                if (it === value) setValue("")
                                else setValue(it)
                                setOpen(false)
                            }
                            Check {
                                className = ClassName("mr-2 h-4 w-4 " + if (value === k) "opacity-100" else "opacity-0")
                            }
                            + v
                        }
                    }
                }
            }
        }
    }
}"""){ 
 ComboboxDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("installation")
 }) {
                org.jetbrains.compose.web.dom.Text("Installation")
            }
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("The Combobox is built using a composition of the ")
                org.jetbrains.compose.web.dom.Code({ classes("bg-muted","py-[0.2rem]","px-[0.3rem]","rounded","text-sm") }) {
                    org.jetbrains.compose.web.dom.Text("Popover {}")
                }
                org.jetbrains.compose.web.dom.Text(" and the ")
                org.jetbrains.compose.web.dom.Code({ classes("bg-muted","py-[0.2rem]","px-[0.3rem]","rounded","text-sm") }) {
                    org.jetbrains.compose.web.dom.Text("Command {}")
                }
                org.jetbrains.compose.web.dom.Text(" components.")
            }
        }
    }
}
